import { useEffect, useRef } from 'react';
import { Box, Stack } from '@mui/material';
import ChatMessage from './ChatMessage';

export default function MessageList({ messages, isTyping, onEdit, onDelete, compact = false }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }

  return (
    <Box sx={{ flex: 1, overflowY: 'auto', px: compact ? 0 : 6, py: compact ? 1.5 : 4 }}>
      {messages.map((msg, index) => {
        const isUser = msg.role === 'user';

        return (
          <Stack key={msg.id || index} direction="row" justifyContent={isUser ? 'flex-end' : 'flex-start'} spacing={compact ? 0.75 : 1.5} mb={compact ? 1 : 2} sx={{ width: '100%' }}>
            <ChatMessage content={msg.content} isUser={isUser} message={msg} onEdit={onEdit} onDelete={onDelete} compact={compact} />
          </Stack>
        );
      })}

      {isTyping && (
        <Stack direction="row" spacing={compact ? 1 : 1.5} mb={compact ? 1 : 2}>
          <Box
            sx={{
              px: compact ? 1.5 : 2,
              py: compact ? 0.75 : 1.3,
              borderRadius: compact ? 1.5 : 2,
              bgcolor: 'grey.100',
              fontSize: compact ? '1rem' : '0.9rem',
              fontStyle: 'italic',
              color: 'text.secondary'
            }}
            ref={bottomRef}
          >
            Phoenix AI is typing…
          </Box>
        </Stack>
      )}

      <div ref={bottomRef} />
    </Box>
  );
}